export const DisplayRecords = ({rows, inputs, removeInputGroup, handleSubmit,handleCancel}) => (
        <div className="container-fluid result_display row" style={{
                position: "fixed",
                top:"0",
                left:"0",
                right:"0",
                bottom:"0",
                background: "linear-gradient(rgba(2, 21, 107, 0.445),rgba(1, 78, 78, 0.445))",
                backdropFilter: "blur(5px)"
            }}>
                <div className='col-md-3'></div>
                <div className='bg-light col-md-6'>
                    <h4>Added products</h4>
                    <table className="table table-stripped">
                        {
                            inputs && inputs.map((elem,index) => (
                                <tr>
                                    <td>{index+1}</td>
                                    {
                                        rows && rows.map(row => (
                                            <td>{elem[row]}</td>
                                        ))
                                    }
                                    <td><button className='btn btn-danger text-dark' onClick={() =>removeInputGroup(index)}>Remove</button></td>
                                </tr>
                            ))
                        }
                    </table>
                    <div>
                        <button className='btn btn-secondary me-2' onClick={handleCancel}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleSubmit}>Approve</button>
                    </div>
                </div>
            </div>
    )